'use client'

import { styled } from 'styled-components'

export const StyledHtml = styled.html`
    font-size: calc(100dvh / 50);
    font-family: 'Open Sans', sans-serif !important;
`

export const StyledBody = styled.body`
    background-color: black;
    position: relative;
    height: 100dvh;
    width: 100dvw;
    overflow: hidden;

    > div {
        overflow: hidden;
    }

    margin: 0;
    padding: 0;
    * {
        margin: 0;
        padding: 0;
    }

    video {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

`
